import React from 'react'
import Achievements from './Achievements'
import EligibilitySlider from './EligibilitySlider'
import SimpleProcess from './SimpleProcess'

const AboutUs = () => {
  return (
    <div>
      <section className="welcome_area ico3" id="home">
        <div className="container">
          <div className="row align-items-center">
             
            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge"> About Us</p>
                    </div>
                    <span className="integration-text">
                      Fast, flexible loans you can trust.
                    </span>
                  </div>
                </div>
                <h1 className="b-text bold">
                  Trusted loans made fast and flexible..
                </h1>
                <p>
                  Finbasket ensures a smooth borrowing experience with quick, flexible, and transparent loan options.
                </p>
                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="/contact-us" className="btn more-btn mr-3">
                    Contact us
                  </a>
                  <a className="btn more-btn" href="/apply-for-loan">
                     
                    Apply For Loan
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>

      <section className="section-padding-0-100 our-facts">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 offset-lg-0 col-md-12 no-padding-left">
              <div className="welcome-meter fadeInUp" data-wow-delay="0.7s">
                <img draggable="false" src="image/about-loan.png" alt="" />
              </div>
            </div>
            <div className="col-12 col-lg-6 offset-lg-0 col-md-10 offset-md-1">
              <div className="who-we-contant mt-s">

                <h4 className="fadeInUp" data-wow-delay="0.3s">
                  Build, edit and create a custom test framework in minutes.
                </h4>
                <p className="fadeInUp" data-wow-delay="0.4s">
                  Finbasket is a reliable financial services company offering a wide range of loan solutions designed to meet every stage of your financial journey. Whether you are planning to buy a home, grow your business, or manage personal expenses, Finbasket provides customized financing options to suit your needs.
                  We offer Home Loan solutions to help you purchase your dream home, refinance your existing property, or renovate your current house. Our Personal Loan options provide quick access to funds for medical emergencies, travel, debt consolidation, or other personal requirements.

                  For entrepreneurs and growing enterprises, our Business Loan products deliver flexible funding to expand operations, manage working capital, or invest in new opportunities. If you're investing in real estate, our Property Loan options are designed to make property purchases simple and affordable.
                </p>
                <p className="fadeInUp" data-wow-delay="0.5s">
                  Students can achieve their academic goals with our convenient Education Loan plans that cover tuition fees and related expenses. We also provide Car Loan and Bike Loan options to make purchasing new or used vehicles easy and budget-friendly.

                  Planning a special occasion? Our Marriage Loan helps you manage wedding expenses without financial stress. Need quick funds against assets? Our Gold Loan offers fast financing with minimal documentation. Additionally, our Loan on Credit Card facility provides instant access to funds based on your credit limit.

                  At Finbasket, we are committed to offering transparent processes, competitive interest rates, and customer-focused service. Whatever your financial requirement, Finbasket is here to support you with the right solution at the right time.
                </p>
                <a
                  className="btn more-btn mt-30 fadeInUp"
                  data-wow-delay="0.6s"
                  href="/about-us"
                >
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SimpleProcess />

      <EligibilitySlider />

      <Achievements /> 
    </div>
  )
}

export default AboutUs
